import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { FondoVideoAmbient } from "../../shared";

function LineaMascara({ texto, delay, clase, testid, reduce }) {
  return (
    <span className="we-mascara">
      <motion.span
        className={clase}
        data-testid={testid}
        initial={{ y: reduce ? 0 : "110%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        {texto}
      </motion.span>
    </span>
  );
}

export default function Portada({ datos }) {
  const { pareja, evento, fotos } = datos;
  const reduce = useReducedMotion();
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 900], [0, reduce ? 0 : 150]);
  const scale = useTransform(scrollY, [0, 900], [1, reduce ? 1 : 1.08]);

  return (
    <header className="we-portada" data-testid="we-portada">
      <motion.div className="we-portada-fondo" style={{ y, scale }}>
        {datos.portadaVideo?.urlYoutube ? (
          <FondoVideoAmbient
            urlYoutube={datos.portadaVideo.urlYoutube}
            poster={datos.portadaVideo.poster || fotos.portada}
          />
        ) : (
          <img
            src={fotos.portada}
            alt={`Fotografía de ${pareja.nombre1} y ${pareja.nombre2}`}
            className="we-portada-img"
          />
        )}
      </motion.div>
      <div className="we-portada-velo" />
      <div className="we-portada-contenido">
        <motion.p
          className="we-portada-frase"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.15 }}
        >
          {pareja.fraseIntroductoria}
        </motion.p>
        <h1 className="we-portada-nombres">
          <LineaMascara texto={pareja.nombre1} delay={0.3} testid="we-nombre-1" reduce={reduce} />
          <LineaMascara texto="&" delay={0.45} clase="we-portada-y" testid="we-nombre-y" reduce={reduce} />
          <LineaMascara texto={pareja.nombre2} delay={0.6} testid="we-nombre-2" reduce={reduce} />
        </h1>
        <motion.p
          className="we-portada-fecha"
          data-testid="we-fecha-portada"
          initial={{ opacity: 0, y: reduce ? 0 : 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.95, ease: [0.22, 1, 0.36, 1] }}
        >
          {evento.fechaLegible} · {evento.ciudad}
        </motion.p>
        <motion.p
          className="we-portada-mensaje"
          initial={{ opacity: 0, y: reduce ? 0 : 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 1.1, ease: [0.22, 1, 0.36, 1] }}
        >
          {pareja.mensajePortada}
        </motion.p>
      </div>
      <motion.a
        href="#we-contenido"
        className="we-portada-bajar"
        aria-label="Desplazarse al contenido de la invitación"
        data-testid="we-boton-bajar"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.4 }}
      >
        <ChevronDown size={18} strokeWidth={1.5} />
      </motion.a>
    </header>
  );
}
